import { render } from "./myMessage.vue?vue&type=template&id=707ffce4&scoped=true"
import script from "./myMessage.vue?vue&type=script&lang=js"
export * from "./myMessage.vue?vue&type=script&lang=js"

import "./myMessage.vue?vue&type=style&index=0&id=707ffce4&lang=scss"
import "./myMessage.vue?vue&type=style&index=1&id=707ffce4&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707ffce4"]])

export default __exports__